module.exports = __webpack_public_path__ + "static/media/header-image-team.6495bace.png";